import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "src/app/shared/http.service";
import { APIEndpoints } from "src/config/apiEndpoint.config";
import { BulkConfigurationDto } from "../models/BulkConfigurationDto";
import { BulkBlobDto } from "../models/BulkBlobDto";
import { BlobContainerType } from "../models/BlobContainerType.enum";
import { HttpEvent, HttpHeaders } from "@angular/common/http";
import { BulkConfigurationType } from "../models/BulkConfigurationType.enum";

@Injectable()
export class BulkService {
  constructor(private readonly httpService: HttpService) {}

  getBulkConfigurations(): Observable<BulkConfigurationDto[]> {
    return this.httpService.get(APIEndpoints.getBulkConfigurations);
  }

  getAllBulkBlobsForConfigurationType(
    bulkConfigurationType: string
  ): Observable<BulkBlobDto[]> {
    return this.httpService.get(
      APIEndpoints.getAllBulkBlobsForConfigurationType(bulkConfigurationType)
    );
  }

  getAllBulkBlobs(): Observable<BulkBlobDto[]> {
    return this.httpService.get(APIEndpoints.getAllBulkBlobs);
  }

  getDownloadLink(
    containerType: BlobContainerType,
    fileName: string
  ): Observable<string> {
    return this.httpService.get(
      APIEndpoints.getDownloadLink(containerType, fileName)
    );
  }

  getSampleFile(
    type: number
  ): Observable<{ fileName: string; fileType: string; data: ArrayBuffer }> {
    return this.httpService.getWithFileResponse(
      APIEndpoints.getBulkSample(type)
    );
  }

  getBlobFileCSV(url) {
    return this.httpService.getCSV(url);
  }

  async uploadBlobFileCSV(file: File, bulkConfigurationType: number) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const data = await new Promise<string>((res) => {
      reader.onload = () => {
        res((reader.result as string).split(",")[1]);
      };
    });

    const dto = {
      fileName: file.name,
      blobData: data,
      bulkConfigurationType: bulkConfigurationType,
      mimeType: "text/csv",
    };

    // TODO: error handling
    return await this.httpService
      .post(APIEndpoints.uploadBulkBlobFile, dto, true)
      .toPromise();
  }
}
